<template>
  <div>
    <filter-group :title="$t('Categories')"
                  id="collapse-categories"
                  v-if="selectedDepartment || mainConfig.alwaysShowCategories"
                  class="ta-filter-group"
                  :collapsed="collapsed"
    >
      <nested-checkbox-list v-model="model"
                   @change="filtersChanged"
                   :label="$t('Categories')"
                   :options="categoriesAsOptions"/>
    </filter-group>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import {LOT_LIST_DEFAULT_PAGE} from "../../../constants";
import {updateLotsRoute} from "../../../helpers";
import FilterGroup from "../../FilterGroup";
import CheckboxList from "../../lot-filters/CheckboxList";
import userConfig from "@/user-config";
import NestedCheckboxList from "@/components/core/NestedCheckboxList";

export default {
  name: "FilterCategoryList",
  components: {NestedCheckboxList, CheckboxList, FilterGroup},
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    model: []
  }),
  computed: {
    ...mapState(['lotQueryParams', 'mainConfig']),
    ...mapGetters(['selectedDepartment', 'categoriesAsOptions'])
  },
  watch: {
    lotQueryParams() {
      this.model = this.lotQueryParams.category
    },
  },
  methods: {
    ...mapMutations(['setLotFilters']),
    filtersChanged() {
      this.setLotFilters({
        category: this.model,
        page: LOT_LIST_DEFAULT_PAGE,
      });
      if (userConfig.autoApplyFilters) {
        updateLotsRoute();
      }
    }
  },
  mounted() {
    this.model = this.lotQueryParams.category
  },
  destroyed() {
    this.setLotFilters({
      category: [],
    });
  }
}
</script>

<style scoped>

</style>
